import { useState } from 'react';
import WhatsAppModal from './WhatsAppModal';

export default function CallToAction() {
  const [modalOpen, setModalOpen] = useState(false);

  const handleConfirm = () => {
    setModalOpen(false);
    window.open('https://wa.me/5514981800454', '_blank', 'noopener,noreferrer');
  };

  return (
    <section className="py-20 bg-gradient-to-br from-black to-gray-900 text-white relative overflow-hidden">
      <WhatsAppModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        onConfirm={handleConfirm}
      />

      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: 'linear-gradient(45deg, #FFD700 25%, transparent 25%, transparent 75%, #FFD700 75%, #FFD700), linear-gradient(45deg, #FFD700 25%, transparent 25%, transparent 75%, #FFD700 75%, #FFD700)',
          backgroundSize: '60px 60px',
          backgroundPosition: '0 0, 30px 30px'
        }}></div>
      </div>

      <div className="max-w-5xl mx-auto px-4 md:px-6 text-center relative z-10">
        <div className="mb-6 md:mb-8">
          <i className="ri-alarm-warning-fill text-5xl md:text-7xl text-yellow-500 mb-4 md:mb-6 inline-block animate-pulse"></i>
        </div>

        <h2 className="text-3xl sm:text-4xl md:text-6xl font-bold mb-4 md:mb-6">
          Precisa de Guincho <span className="text-yellow-500">Agora?</span>
        </h2>
        
        <p className="text-base md:text-2xl text-gray-300 mb-8 md:mb-12 max-w-3xl mx-auto">
          Não perca tempo! Nossa equipe está pronta para atendê-lo em qualquer lugar do Brasil. 
          Chegamos em até 10 minutos.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 md:gap-6 justify-center items-center mb-10 md:mb-12">
          <button
            onClick={() => setModalOpen(true)}
            className="w-full sm:w-auto bg-green-500 text-white font-bold px-8 py-5 md:px-12 md:py-6 rounded-full text-base md:text-xl hover:bg-green-400 transition-all shadow-2xl hover:shadow-green-500/50 transform hover:scale-105 whitespace-nowrap cursor-pointer border-none"
          >
            <i className="ri-whatsapp-fill mr-3"></i>
            CHAMAR NO WHATSAPP
          </button>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-8 mt-8 md:mt-16">
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-5 md:p-6 border border-white/20">
            <i className="ri-time-fill text-3xl md:text-4xl text-yellow-500 mb-3 md:mb-4"></i>
            <h3 className="font-bold text-lg md:text-xl mb-2">Atendimento Rápido</h3>
            <p className="text-gray-300 text-sm md:text-base">Chegamos em até 10 minutos no local</p>
          </div>
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-5 md:p-6 border border-white/20">
            <i className="ri-shield-check-fill text-3xl md:text-4xl text-yellow-500 mb-3 md:mb-4"></i>
            <h3 className="font-bold text-lg md:text-xl mb-2">Seguro e Confiável</h3>
            <p className="text-gray-300 text-sm md:text-base">Equipamentos modernos e profissionais qualificados</p>
          </div>
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-5 md:p-6 border border-white/20">
            <i className="ri-24-hours-fill text-3xl md:text-4xl text-yellow-500 mb-3 md:mb-4"></i>
            <h3 className="font-bold text-lg md:text-xl mb-2">Disponível 24/7</h3>
            <p className="text-gray-300 text-sm md:text-base">Todos os dias, incluindo feriados</p>
          </div>
        </div>
      </div>
    </section>
  );
}
